import { color } from "minimum-ui/tokens";
import { rem } from "polished";
import styled from "styled-components";
import { composed } from "theme/utilities";

import Base from "./base";

/**
 * font-size: 14px, line-height: 24px, letter-spacing: 0.005em, font-weight: 400
 */
export const P = styled(Base).attrs(composed("p"))`
  font-size: ${rem(14)};
  line-height: ${rem(24)};
  letter-spacing: 0.005em;
  font-weight: 400;
`;

export const Hyperlink = styled(Base)`
  font-size: 1em;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: 400;
  color: ${color.blue[300]};
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: ${color.blue[400]};
    text-decoration: underline;
  }
`;
